import Layout from '@/layout'

export default {
  path: '/s_slip_note_opts',
  redirect: '/s_slip_note_opts/list',
  component: Layout,
  children: [
    {
      path: 'list',
      name: '備考選択肢一覧',
      component: () => import('@/views/s_slip_note_opt')
    }
  ]
}
